"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "8e30a09",
    "raw": "v2.28.0",
    "semverString": "2.28.0"
};
//# sourceMappingURL=version.js.map